import {ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {UserQueryRequest} from "./user-query";

export const DumpPermissionUrl = `/dump_permission`;
export const DumpPermissionMethod = ERequestType.TYPE_GET;

export interface DumpPermissionBody extends UserQueryRequest {
	project?: string;
}

export interface IPermissionDump {
	permName: string;
	available: number;
	expire: number;
	scope: string;
}

export interface DumpPermissionResponse extends ApiResponse {
	list: IPermissionDump[];
}
